<template>
  <div>
  <v-flex xs10 offset-xs1>
    <div class="fl" style="width: 100%">
      <div class="golden-left">
        <h1 class="mb-4">{{ 'reports-of-sickness-import.new-title' | translate }}</h1>
      </div>
    </div>

    <div class="fl" style="width: 100%">
      <div class="golden-left">
        <p>{{ 'reports-of-sickness-import.new-description' | translate }}</p>
        <reports-of-sickness-import-file class='mt-5' v-if="isImportFileActiveView" />
        <reports-of-sickness-import-report class='mt-5' v-if="isImportReportActiveView" />
      </div>

      <div class="golden-right">
        <ProgressStepper :steps="this.steps" :sticky="320" />
      </div>
    </div>
  </v-flex>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import ReportsOfSicknessImportFile from '@/views/components/reports-of-sickness-import-new/ReportsOfSicknessImportFile.vue';
import ReportsOfSicknessImportReport from '@/views/components/reports-of-sickness-import-new/ReportsOfSicknessImportReport.vue';
import ReportsOfSicknessImportNewConstants from '@/views/constants/reports-of-sickness-import-new';

import ProgressStepper from '@aevitae/aevitaeui/1_molecules/stepper/ProgressStepper.vue';

export default {
  name: 'ReportsOfSicknessImport',
  components: {
    ProgressStepper,
    ReportsOfSicknessImportFile,
    ReportsOfSicknessImportReport
  },
  computed: {
    ...mapGetters({
      steps: 'reportsOfSicknessImportNewSteps',
      activeView: 'reportsOfSicknessImportNewActiveView'
    }),

    isImportFileActiveView () {
      return this.activeView === ReportsOfSicknessImportNewConstants.Views.ImportFile;
    },

    isImportReportActiveView () {
      return this.activeView === ReportsOfSicknessImportNewConstants.Views.ImportReport;
    }
  }
};
</script>

<style lang='scss' scoped>

</style>
